import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col } from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// views
import EntradaIndividualForm from "./EntradaIndividualForm.jsx";

// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDate, formateDateApi } from "../../helpers/formats.js";

// api
import entradaindividual_api from "../../api/entradaindividual_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function EntradaIndividualLista() {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, getValues } = useForm({ mode: "onBlur" });

  const [list_table, set_list_table] = React.useState([]);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [showDetail, set_showDetail] = React.useState(false);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    set_showDetail(true);
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);

    let data = getValues();
    loadList(data);
  }

  const loadList = (data) => {
    let json_submit = {
      localId: session.localId,
      dataInicial: formateDateApi(data.dataInicial),
      dataFinal: formateDateApi(data.dataFinal)
    }
    setLoading(true);
    entradaindividual_api.getList(json_submit).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const onSubmit = (data) => {
    loadList(data);
  }

  useEffect(() => {
    let data = getValues();
    loadList(data);
  }, []);

  return (
    <>
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            <button type="button" onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Nova Entrada</button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Entradas Individuais</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg="3" md="3" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Data Inicial:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="date"
                          defaultValue={formateDateApi(new Date())}
                          name="dataInicial"
                          innerRef={register({ required: true })}
                        />
                        {errors.dataInicial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Data Final:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="date"
                          defaultValue={formateDateApi(new Date())}
                          name="dataFinal"
                          innerRef={register({ required: true })}
                        />
                        {errors.dataFinal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12">
                      <Button color="info" className="btn-mobile mt-4" type="submit"><i className="fas fa-search"></i> Pesquisar</Button>
                    </Col>
                  </Row>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Identificação', field: 'identificacao' },
                      { title: 'Endereço', field: 'endereco' },
                      { title: 'Data/Hora', field: 'dataHora', render: rowData => formateDate(rowData.dataHora) }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{...table_style, filtering: false, exportButton: true }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <EntradaIndividualForm item={rowEdit} handleReturn={handleReturn}></EntradaIndividualForm>
      }

    </>

  );
}